import { combineReducers } from 'redux';
import types from './types';

const lists = (state = { searchValue: '' }, action) => {
  const { payload, meta } = action;
  switch (action.type) {
    case types.RESET_SEARCH: {
      return {
        ...state,
        searchValue: '',
      };
    }
    case types.SET_SEARCH_VALUE: {
      return {
        ...state,
        searchValue: payload,
      };
    }
    case types.FETCH_LIST_INIT: {
      return {
        ...state,
        [meta.id]: {
          isFetching: true,
          error: false,
        },
      };
    }
    case types.FETCH_LIST_ERROR: {
      return {
        ...state,
        [meta.id]: {
          isFetching: false,
          error: true,
          errorMessage: payload.toString(),
        },
      };
    }
    case types.FETCH_LIST: {
      return {
        ...state,
        [meta.id]: {
          ...state[meta.id],
          isFetching: false,
          ...payload,
        },
      };
    }
    default:
      return state;
  }
};

const listsReducer = combineReducers({
  lists,
});

export default listsReducer;
